export const formatNumberForTwoDecimalPlace = (x) => {
  const str = String(x).split(".");
  if (str.length <= 1) {
    return x.toFixed(2);
  }
  return Number(`${str[0]}.${str[1].substring(0, 2)}`).toFixed(2);
};

export const formatFuelBalance = (fuelAmount, showUnit = true) => {
  let text = "";
  if (!fuelAmount) {
    text = "0";
  } else if (fuelAmount < 999) {
    text = `${fuelAmount}`;
  } else {
    if (fuelAmount % 1000 === 0) {
      text = `${fuelAmount / 1000}`;
    } else {
      text = `${formatNumberForTwoDecimalPlace(fuelAmount / 1000)}`;
    }
  }
  if (showUnit) {
    return `${text} ${fuelAmount < 999 ? "ml" : "Ltr"}`;
  } else {
    return text;
  }
};